@for(bookmark of publicBookmarks(); let i = $index; track i){
<h3 class="bookmark">
  {{ bookmark.title }}
</h3>
} @if (messageIsMaster()) {
<div class="masterMessageBaloon">
  <div
    class="masterMessage"
    (contextmenu)="onContextMenu($event)"
    (touchstart)="onPressStart($event)"
    (touchend)="onPressEnd()"
    (touchmove)="onPressEnd()"
    (touchcancel)="onPressEnd()"
  >
    <p class="masterMessageLabel">{{ 'chat.message.master' | translate }}</p>
    <re-message-content [content]="message().text"></re-message-content>
    @if (allowCharacters() && sheetUpdateRecap().length) {
    <div class="masterSheetUpdateRecap">
      <p class="masterSectionLabel">{{ 'chat.message.sheetUpdate' | translate }}</p>
      @for (entry of sheetUpdateRecap(); track entry.characterId) {
      <p class="masterSheetUpdateRecap-character">
        <strong>{{ entry.characterName }}</strong>
      </p>
      @for (row of entry.applied; track row.label + row.before) {
      <p class="masterSheetUpdateRecap-row">
        <span class="masterSheetUpdateRecap-label">{{ row.label }}</span>:
        <span class="masterSheetUpdateRecap-before">{{ row.before }}</span>
        <span class="masterSheetUpdateRecap-arrow" aria-hidden="true">→</span>
        <span class="masterSheetUpdateRecap-after">{{ row.after }}</span>
      </p>
      }
      @if (entry.skipped?.length) {
      @for (skip of entry.skipped; track skip.label + skip.reason) {
      <p class="masterSheetUpdateRecap-skipped">
        {{ 'chat.message.notApplied' | translate: { label: skip.label, reason: skip.reason } }}
      </p>
      }
      }
      }
    </div>
    }
    @if (showMasterSuggestions() && sceneGateRolls().length) {
    <div class="masterSceneGateRolls">
      <p class="masterSectionLabel">{{ 'chat.message.mandatoryRoll' | translate }}</p>
      @for (op of sceneGateRolls(); track op.characterId + '-' + op.name) {
      <div class="masterSceneGateRoll">
        <p class="masterSceneGateRoll-title">{{ op.name }}</p>
        @if (op.description) {
        <p class="masterSceneGateRoll-desc">{{ op.description }}</p>
        }
        <ion-button
          size="small"
          fill="outline"
          color="primary"
          [disabled]="!rollEnabled(op) || suggestionsLocked()"
          [title]="suggestionsBusyHint() || rollDisabledHint(op)"
          (click)="openSceneGateRoll(op)"
        >
          {{ 'chat.message.roll' | translate }}
        </ion-button>
      </div>
      }
    </div>
    }
    @if (showMasterSuggestions() && showSuggestedReplies()) {
      @if (useProminentSuggestedReplies()) {
    <div class="masterSuggestedMessages masterSuggestedMessages--prominent">
      <div class="masterSuggestedMessages__header">
        <p class="masterSuggestedMessages__label">
          <ion-icon name="chatbubbles-outline" aria-hidden="true"></ion-icon>
          {{ 'chat.message.suggestedReplies' | translate }}
        </p>
        <p class="masterSuggestedMessages__hint">{{ 'chat.message.suggestedRepliesHint' | translate }}</p>
      </div>
      @for (entry of visibleSuggestedMessages(); track entry.characterId) {
        <div class="masterSuggestedMessages__group">
          @if (suggestedReplyCharacterName(entry.characterId)) {
          <p class="masterSuggestedMessages__char">{{ suggestedReplyCharacterName(entry.characterId) }}</p>
          }
          @for (choice of entry.choices; track $index) {
          <button
            type="button"
            class="masterSuggestedChoice"
            [disabled]="suggestionsLocked()"
            [attr.title]="suggestionsBusyHint() || null"
            (click)="pickSuggestedReply(entry.characterId, $index, choice)"
          >
            <span class="masterSuggestedChoice__header">
              <span class="masterSuggestedChoice__label">{{ suggestedChoiceLabel(choice) }}</span>
              @if (suggestedChoiceHasRoll(choice)) {
              <ion-icon class="masterSuggestedChoice__roll" name="dice-outline" aria-hidden="true"></ion-icon>
              }
            </span>
            <span class="masterSuggestedChoice__preview">{{ suggestedChoicePreview(choice) }}</span>
            @if (suggestedChoiceRollDescription(choice); as rollDesc) {
            <span class="masterSuggestedChoice__roll-desc">{{ rollDesc }}</span>
            }
          </button>
          }
        </div>
      }
    </div>
      } @else {
    <div class="masterSuggestedMessages">
      <ion-button
        size="small"
        fill="clear"
        color="medium"
        class="masterSuggestedMessagesBtn"
        [disabled]="suggestionsLocked()"
        [title]="suggestionsBusyHint() || null"
        (click)="openSuggestedRepliesModal()"
      >
        <ion-icon slot="start" name="chatbubbles-outline"></ion-icon>
        {{ 'chat.message.suggestedReplies' | translate }}
      </ion-button>
    </div>
      }
    }
    @if (showMasterSuggestions() && suggestedActions().length) {
    <div class="masterSuggestedActions">
      <p class="masterSectionLabel">{{ 'chat.message.availableActions' | translate }}</p>
      @for (action of suggestedActions(); track action.action) {
      <ion-button
        expand="block"
        [fill]="actionButtonFill(action)"
        [color]="actionColor(action)"
        [disabled]="!actionEnabled(action) || suggestionsLocked()"
        [title]="suggestionsBusyHint() || actionDisabledHint(action)"
        (click)="suggestedActionClick.emit(action)"
      >
        @if (actionIcon(action)) {
        <ion-icon slot="start" [name]="actionIcon(action)"></ion-icon>
        }
        {{ actionLabel(action) }}
      </ion-button>
      }
    </div>
    }
  </div>
</div>
} @else if (messageIsLore()) {
<div class="masterMessageBaloon">
  <div
    class="masterMessage loreMessage"
    (contextmenu)="onContextMenu($event)"
    (touchstart)="onPressStart($event)"
    (touchend)="onPressEnd()"
    (touchmove)="onPressEnd()"
    (touchcancel)="onPressEnd()"
  >
    <p class="masterMessageLabel">{{ 'chat.lore.label' | translate }}</p>
    <re-message-content [content]="message().text"></re-message-content>
    @if (correctionProposals().length) {
    <div class="loreCorrections">
      @for (proposal of correctionProposals(); track proposal.id) {
      <div class="loreCorrection" [class.loreCorrection--pending]="proposal.status === 'pending'">
        <p class="loreCorrection-type">{{ correctionTypeLabel(proposal) }}</p>
        <p class="loreCorrection-reason">{{ proposal.reason }}</p>
        <p class="loreCorrection-detail">
          @switch (proposal.type) {
            @case ('message') { {{ 'chat.lore.detailMessage' | translate: { id: proposal.targetMessageId } }} }
            @case ('graph') { {{ 'chat.lore.detailGraph' | translate }} }
            @case ('story') { {{ 'chat.lore.detailStory' | translate: { name: proposal.newStoryName } }} }
            @case ('chapter') { {{ 'chat.lore.detailChapter' | translate: { title: proposal.newChapterTitle } }} }
          }
        </p>
        @if (proposal.status === 'pending') {
        <div class="loreCorrection-actions">
          <ion-button size="small" color="primary" (click)="approveCorrection(proposal)">
            {{ 'chat.lore.applyCorrection' | translate }}
          </ion-button>
          <ion-button size="small" fill="clear" color="medium" (click)="rejectCorrection(proposal)">
            {{ 'chat.lore.rejectCorrection' | translate }}
          </ion-button>
        </div>
        } @else {
        <p class="loreCorrection-status">{{ correctionStatusLabel(proposal) }}</p>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
} @else if (messageIsSystemSeparator()) {
<div class="newMessagesBaloon">
  <div class="newMessages">
    <re-message-content [content]="message().text"></re-message-content>
  </div>
</div>
} @else { @if(!messageIsBookmark()){
<div
  class="message-row"
  [class.message-row--private]="usePrivateMessageLayout()"
  [class.message-row--me]="usePrivateMessageLayout() && message().type === 'me'"
  [class.message-row--other]="usePrivateMessageLayout() && message().type === 'user'"
  (contextmenu)="onContextMenu($event)"
  (touchstart)="onPressStart($event)"
  (touchend)="onPressEnd()"
  (touchmove)="onPressEnd()"
  (touchcancel)="onPressEnd()"
>
  <ion-item
    [class.impersonate]="message().impersonate"
    [class.me]="message().type === 'me'"
    [class.show-user-info]="message().showUserInfo"
    lines="none"
  >
    <div class="avatar-slot" slot="start">
      @if (message().showUserInfo) { @if(message().impersonate) {
      <div
        slot="start"
        class="avatar"
        (click)="showCharacter.emit(message().impersonate!)"
      >
        <img
          src="{{
            message().impersonateData?.avatar ??
              '/assets/placeholder-avatar.png'
          }}"
          alt=""
        />
      </div>
      } @else {
      <div class="avatar" (click)="showProfile.emit(message().userId)">
        <img
          src="{{
            message().userData?.avatar ?? '/assets/placeholder-avatar.png'
          }}"
          alt=""
        />
      </div>
      } }
    </div>
    <div class="message-inner-container">
      @if (message().showUserInfo) {
      <div class="username">
        @if(message().impersonate) {
        <b>{{ message().impersonateData?.name }}</b>
        } @else {
        <b>{{ message().userData?.displayName }}</b>
        }
        <span class="opacity-50 text-sm">{{
          message().createdAt | date : "HH:mm"
        }}</span>
      </div>
      } @if (message().messageQuoted) {
      <div class="quote" (click)="goToMessageQuoteHandler()">
        <div class="quote-content">
          <b>{{ message().messageQuoted?.userData?.displayName }}</b>
          <p>
            <re-message-content
              [content]="message().messageQuoted?.text"
              [preview]="true"
            ></re-message-content>
          </p>
        </div>
      </div>
      } @if(message().text){
      <re-message-content [content]="message().text"></re-message-content>
      } @if (message().image) { @defer(on viewport){
      <re-supabase-image [src]="message().image!"></re-supabase-image>
      } @placeholder {
      <div class="image-placeholder"></div>
      }       }
      @if (message().createdAt !== message().updatedAt || (!message().id && message().localId)) {
      <div class="message-footer">
        <div class="message-footer-inner">
          @if (message().createdAt !== message().updatedAt) {
          <span class="updatedMessage">
            <i>{{ 'chat.message.edited' | translate }}</i>
          </span>
          } @if(!message().id && message().localId){
          <span class="messagePending">
            <ion-icon name="hourglass-outline"></ion-icon>
          </span>
          }
        </div>
      </div>
      }
    </div>
  </ion-item>
</div>
} }
